import { request } from './request';

// Persist before submitting so a reload or ambiguous response can reuse the same charge.
export async function startBackgroundUpscale(owner, sourceProcessId, signal) {
  const key = `erion.background-upscale.${owner}.${sourceProcessId}`;
  let id = localStorage.getItem(key);
  if (id) {
    try {
      const existing = await request(`/api/gallery/creation-requests/${encodeURIComponent(id)}`, { signal });
      if (['failed', 'error'].includes(existing.status)) {
        localStorage.removeItem(key);
        throw new Error(existing.coin_refunded ? '이전 생성에 실패하여 RION이 반환되었습니다. 다시 생성할 수 있어요.' : '이전 생성에 실패했습니다. 다시 시도해 주세요.');
      }
      return existing;
    }
    catch (error) { if (error.status !== 404) throw error; }
  } else {
    id = crypto.randomUUID();
    localStorage.setItem(key, id);
  }
  return request('/api/gallery/background-upscale', { method: 'POST', signal,
    body: { request_id: id, source_process_id: sourceProcessId } });
}
export async function waitForCreation(initial, signal, interval = 3000) {
  let data = initial;
  const started = Date.now();
  while (!['completed', 'failed', 'error'].includes(data.status)) {
    if (Date.now() - started > 300000) throw new Error('아직 생성 중입니다. 갤러리에서 결과를 확인하거나 다시 확인해 주세요.');
    await new Promise((resolve, reject) => {
      const abort = () => { clearTimeout(timer); reject(new DOMException('Aborted', 'AbortError')); };
      const timer = setTimeout(() => { signal?.removeEventListener('abort', abort); resolve(); }, interval);
      if (signal?.aborted) abort(); else signal?.addEventListener('abort', abort, { once: true });
    });
    data = await request(`/api/gallery/creation-requests/${encodeURIComponent(initial.request_id)}`, { signal });
  }
  if (data.status !== 'completed' || !data.result_url) throw new Error(data.coin_refunded ? '생성에 실패하여 RION이 반환되었습니다.' : '이미지를 생성하지 못했습니다.');
  return data;
}
